import Swiper from 'swiper/bundle';

const titles = document.querySelectorAll('.swiper .swiper-slide');
let title = [];

titles.forEach(function(element) {
    title.push(element.dataset.title);
});

const mySwiper = new Swiper ('.hiw-slider .swiper', {
    loop: true,
    allowTouchMove: false,
    pagination: {
        el: '.hiw-slider .swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return `<span class="${className}">${title[index]}</span>`;
        },
    },
    speed: 600,
    navigation: {
        nextEl: '.hiw-slider__btn-next',
        prevEl: '.hiw-slider__btn-prev',
    },
});

$(document).ready(function() {
    const mySwiper = new Swiper(".roadmap .swiper-container", {
        // slidesPerView: 1,
        slidesPerView: 'auto',
        centeredSlides: true,
        // roundLengths: true,
        initialSlide: 1,
        loop: false,
        // loopAdditionalSlides: 30,
        speed: 500,
        preventInteractionOnTransition: true,
        // effect: "fade",
        allowTouchMove: false,
        navigation: {
            nextEl: ".roadmap .roadmap__btn-next",
            prevEl: ".roadmap .roadmap__btn-prev"
        },
        breakpoints: {
            650: {
                speed: 700
            }
        }
    });
});

if(document.querySelector('.hiw-slider')) {
    $(window).on('resize scroll DOMContentLoaded', function() {
        if(window.innerWidth <= 1024) {
            let postContainer = document.querySelector('.about__container');

            function spacingLeft(from, to) {
                let style = window.getComputedStyle(from),
                    computedSpaceLeft = style.getPropertyValue('margin-left').slice(0, -2),
                    computedSpaceLeftNumber = parseInt(computedSpaceLeft),
                    wrap = to;

                wrap.style.marginLeft = `${computedSpaceLeftNumber}px`;
                // wrap.style.paddingRight = `${computedSpaceLeftNumber + 10}px`;
            }

            function spacingRight(from, to) {
                let style = window.getComputedStyle(from),
                    computedSpaceRight = style.getPropertyValue('margin-left').slice(0, -2),
                    computedSpaceRightNumber = parseInt(computedSpaceRight),
                    wrap = to;

                wrap.style.paddingRight = `${computedSpaceRightNumber}px`;
                // wrap.style.paddingRight = `${computedSpaceLeftNumber + 10}px`;
            }

            function spacingBoth(from, to) {
                let style = window.getComputedStyle(from),
                    computedSpaceLeft = style.getPropertyValue('margin-left').slice(0, -2),
                    computedSpaceLeftNumber = parseInt(computedSpaceLeft),
                    wrap = to;

                wrap.style.marginLeft = `${computedSpaceLeftNumber + 25}px`;
                wrap.style.marginRight = `${computedSpaceLeftNumber + 25}px`;
            }

            if(postContainer) spacingLeft(postContainer, document.querySelector('.hiw-slider .swiper-pagination'));
            if(postContainer) spacingBoth(postContainer, document.querySelector('.hiw-slider__swiper'));
            if(postContainer) spacingRight(postContainer, document.querySelector('.hiw-slider__pagination-wrap'));
        }
    });
}

const howToLine = document.querySelector('.how-to-line--mob');

$(document).ready(function() {
    const mySwiper = new Swiper (howToLine, {
        slidesPerView: 1,
        speed: 500,
        navigation: {
            nextEl: ".how-to-line--mob .how-to-line__btn-next",
            prevEl: ".how-to-line--mob .how-to-line__btn-prev"
        },
    });
});
